import { Pagination, PostOrPage, PostsOrPages, SettingsResponse, Tags } from "@tryghost/content-api";
import { getGhostPosts, getGhostSettings, getGhostTags } from "../../api/ghost";
import { BlogHeroComponent } from "../../components/BlogHeroComponent";
import { BlogGenericPageLayout } from "../../pagelayouts/blog/generic";
import { APPLICATION_ROUTES } from "../../shared-logic/routes";

const BlogHPPage = ({ ...rest }: { postOrPages: PostsOrPages; tags: Tags; pagination: Pagination; settings: SettingsResponse }) => (
    <BlogGenericPageLayout
        {...rest}
        postOrPages={rest.postOrPages.slice(1) as PostsOrPages}
        headerComponent={<BlogHeroComponent post={rest.postOrPages[0] as PostOrPage} />}
        title={"A Blog on Authory — The Portfolio Builder & Content Backup Tool | Page 1"}
        description={rest.settings.meta_description || undefined}
        canonicalUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}${APPLICATION_ROUTES.BLOG}`}
    />
);

export async function getStaticProps(ctx: any) {
    try {
        const postOrPages = await getGhostPosts();
        const { pagination } = postOrPages.meta;
        const tags = await getGhostTags();
        const settings = await getGhostSettings();

        return {
            props: {
                postOrPages,
                tags,
                pagination,
                settings
            },
            revalidate: 60
        };
    } catch {
        if (ctx.res) {
            ctx.res.statusCode = 404;
            ctx.res.end();
        }

        return { props: { statusCode: 404 } };
    }
}

export default BlogHPPage;
